import script from "./ShareCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareCard.vue?vue&type=script&setup=true&lang=js"

import "./ShareCard.vue?vue&type=style&index=0&id=ed25bd30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed25bd30"]])

export default __exports__